// extracted by mini-css-extract-plugin
export default {"contentback":"LinkBack_contentback__t8lBt","back":"LinkBack_back__yz-9d"};